import {
  PolicyContainerApp,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
} from "styles/PolicyCommon";

const PremiumService = () => {
  return (
    <PolicyContainerApp>
      <h1 className="hide">열달후에</h1>
      <PolicyTitle>열달후에 프리미엄 서비스 이용약관 (ver. 2.0)</PolicyTitle>
      <PolicySectionTitle>제1조 (숙지 의무)</PolicySectionTitle>
      <PolicyText>
        회원은 열달후에 프리미엄 서비스에 가입하기 전에 본 약관의 내용을 반드시
        숙지해야 합니다.
      </PolicyText>
      <PolicySectionTitle>제2조 (프리미엄 서비스의 정의)</PolicySectionTitle>
      <PolicyList>
        <li>
          ① 열달후에 프리미엄 서비스(이하 “프리미엄 서비스”)는 열달후에 서비스
          이용 회원에게 일정 조건에 따라 혜택을 제공하는 제도입니다.
        </li>
        <li>
          ② 프리미엄 서비스는 무료형과 유료형으로 구분됩니다.
          <PolicyList>
            <li>
              1. 무료 프리미엄 서비스
              <br />• 가입비 없이 제공됩니다.
              <br />• 제휴사를 통해 이용 가능하며, 이 경우 개인정보 제3자 제공
              동의가 필요합니다.
              <br />• 동의 시 제휴사의 마케팅 안내를 받을 수 있습니다.
            </li>
            <li>
              2. 유료 프리미엄 서비스
              <br />
              • 인앱 결제를 통해 가입하며, 결제는 일회성으로 이루어집니다.
              <br />• 결제 후 서비스 이용 기간 동안 프리미엄 혜택이 제공됩니다.
              <br />• 향후 정책 변경에 따라 가입 조건이 변경되거나 구독 방식으로
              전환될 수 있으며, 이에 대해서는 사전 고지 후 약관 개정이
              이루어집니다.
            </li>
          </PolicyList>
        </li>
      </PolicyList>
      <PolicySectionTitle>제3조 (가입 및 탈퇴)</PolicySectionTitle>
      <PolicyList>
        <li>① 프리미엄 서비스 혜택은 회원 탈퇴 전까지 유지됩니다.</li>
        <li>② 열달후에 회원 탈퇴 시 프리미엄 서비스도 자동으로 해지됩니다.</li>
        <li>
          ③ 「열달후에 이용약관」 제11조(서비스 이용의 제한 및 중지)에 따라 회원
          자격이 제한·정지될 경우, 프리미엄 서비스 이용도 함께 제한됩니다.
        </li>
      </PolicyList>
      <PolicySectionTitle>제4조 (가입 조건)</PolicySectionTitle>
      <PolicyList>
        <li>
          ① 프리미엄 서비스 혜택은 각 모드별 가입 조건을 충족한 회원이 신청할 수
          있습니다.
        </li>
        <li>
          ② 가입 조건은 다음과 같습니다.
          <PolicyList>
            <li>
              1. 임신 프리미엄 임신 모드 이용 회원 중 임신 주수 20주 6일 이하일
              경우 가입 가능합니다.
            </li>
            <li>
              2. 육아 프리미엄 육아 모드 이용 회원 중 자녀의 월령이 0개월 이상일
              경우 가입 가능합니다.
            </li>
          </PolicyList>
        </li>
      </PolicyList>
      <PolicySectionTitle>제5조 (가입 혜택)</PolicySectionTitle>
      <PolicyText>
        프리미엄 서비스 혜택은 유료/무료, 임신/육아 유형에 따라 상이하게
        제공됩니다.
      </PolicyText>
      <PolicyList>
        <li>
          ① 임신·육아 유·무료 프리미엄 공통 혜택
          <PolicyList>
            <li>
              1. 프리미엄 전용 콘텐츠 이용
              <br />• 프리미엄 서비스 전용 콘텐츠를 이용할 수 있습니다.
              <br />• 콘텐츠의 제공 범위 및 조건은 회사 정책에 따라 변경될 수
              있습니다.
            </li>
          </PolicyList>
        </li>
        <li>
          ② 임신·육아 무료 프리미엄 공통 혜택
          <PolicyList>
            <li>
              1. 생애주기 맞춤 정보 제공
              <br />• 제휴 서비스를 통해 맞춤형 정보와 혜택을 제공합니다.
              <br />• 제휴처는 회사 방침에 따라 변경될 수 있으며, 개인정보
              제공이 필요한 경우 회원의 동의를 받습니다.
            </li>
            <li>
              2. 프리미엄 회원 전용 이벤트 참여
              <br />
              • 축하박스, 체험단 등 다양한 이벤트에 참여할 수 있습니다.
              <br />
              • 프리미엄 회원은 일반 회원 대상 이벤트에도 중복 참여할 수 있으며,
              이벤트 규정에 따라 운영됩니다.
              <br />• 프리미엄 전용 이벤트는 비정기적으로 진행되며, 이벤트별
              조건과 내용은 상이할 수 있습니다.
            </li>
          </PolicyList>
        </li>
        <li>
          ③ 임신 무료 프리미엄 단독 혜택
          <PolicyList>
            <li>
              1. 열달 포토북 제작 서비스
              <br />• 앱에 기록된 태아 성장 데이터를 바탕으로 포토북을 제작할 수
              있습니다.
              <br />
              • 포토북은 출산 이후 신청 가능하며, 출산일 및 출생 정보가
              등록되어야 합니다.
              <br />• 편집 완료 후에는 디지털 저장 또는 인쇄본 배송을 선택할 수
              있습니다.
            </li>
          </PolicyList>
        </li>
      </PolicyList>
      <PolicySectionTitle>제6조 (기타)</PolicySectionTitle>
      <PolicyList>
        <li>
          ① 본 약관에서 정하지 않은 개인정보 처리에 관한 사항은 「열달후에
          개인정보 처리방침」을 따릅니다.
        </li>
        <li>
          ② 본 약관에서 정하지 아니한 회원 정책 및 서비스 이용에 관한 사항은
          「열달후에 이용약관」을 따릅니다.
        </li>
      </PolicyList>
      <PolicySectionTitle>제7조 (부칙)</PolicySectionTitle>
      <PolicyText>본 약관은 2025년 9월 01일부터 시행합니다.</PolicyText>
    </PolicyContainerApp>
  );
};

export default PremiumService;
